import {
  OnboardingPartnerServiceMethods,
  OnboardingServices,
} from 'clickNgo/configs/service/onboarding'
import { WebSocketStoreKeys } from 'clickNgo/configs/service/ws'
import { IEditableForm } from 'clickNgo/models/crud/utils'
import { getAccessToken } from 'cng-common/helpers/access'
import WebSocketStore from 'core/classes/services/WebSocketStore'

import { IPartner, IPartnerAdditional } from '../models'

import { invalidatePartnerDataCache } from './cache'

interface IUpdatePartnerAdditionalResponse extends Pick<IPartner, 'entryId458'> {
  error: { message: string }[]
}

export const updatePartnerAdditional = async (
  partner: Omit<IPartnerAdditional, keyof IEditableForm> &
    Pick<IPartner, 'partnerId' | 'entryId458'>
) => {
  const token = getAccessToken() || ''
  const payload = partner
  const wsClient = WebSocketStore.get(WebSocketStoreKeys.Onboarding)

  const response = await wsClient.call<IUpdatePartnerAdditionalResponse>({
    service: OnboardingServices.Partner,
    action: OnboardingPartnerServiceMethods.UpdateAdditional,
    payload,
    withoutTokenRefresh: true,
    isAuth: true,
    returnError: true,
    token,
  })

  invalidatePartnerDataCache(partner.partnerId)

  return response
}
